import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyMantra() {
  const features = ['Médicas especializadas — no técnicos, médicas reales', 'Tecnología de última generación importada', 'Resultados visibles y documentados', 'Atención en 5 sedes en Uruguay'];
  return <section id="nosotros" className="py-24 bg-white" data-id="element-182">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-183">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1" data-id="element-185">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight mb-6" data-id="element-186">
              No es solo estética.
              <br data-id="element-187" />
              Es medicina.
            </h2>
            <p className="text-charcoal/70 text-lg leading-relaxed" data-id="element-188">
              En Mantra, cada tratamiento es supervisado y aplicado por médicas
              certificadas. No trabajamos con técnicas, trabajamos con
              diagnósticos personalizados.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full" data-id="element-189">
            <div className="bg-ivory p-8 md:p-10 rounded-3xl shadow-soft" data-id="element-190">
              <ul className="space-y-6" data-id="element-191">
                {features.map((feature, i) => <motion.li key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-192">
                    <div className="text-sage mt-1 flex-shrink-0" data-id="element-193">
                      <CheckCircle2 size={24} data-id="element-194" />
                    </div>
                    <span className="text-charcoal font-medium text-lg" data-id="element-195">
                      {feature}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}